import * as tslib_1 from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import Backdrop from './Backdrop';
import { createChainFunction } from '../utils/helpers';
import ModalContainer from './ModalContainer';
import omit from 'lodash/omit';
var modalRoot;
var MODAL_ROOT_CLASSNAME = 'sinoui-modal-root';
export { MODAL_ROOT_CLASSNAME };
/**
 * 获取模态框的根元素
 *
 * @returns {HTMLElement} 返回模态框的根元素
 */
export function getModalRoot() {
    if (!modalRoot) {
        modalRoot = document.getElementById('SinouiModalRoot');
        if (!modalRoot) {
            modalRoot = document.createElement('div');
            modalRoot.classList.add(MODAL_ROOT_CLASSNAME);
            document.body.appendChild(modalRoot);
        }
    }
    return modalRoot;
}
function getHasTransition(props) {
    /* eslint no-prototype-builtins: 0 */
    return props.children
        ? React.Children.only(props.children).props.hasOwnProperty('in')
        : false;
}
/**
 * 模态框
 */
var Modal = /** @class */ (function (_super) {
    tslib_1.__extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.el = document.createElement('div');
        _this.state = {
            exited: !props.open,
        };
        _this.onBackdropClick = _this.onBackdropClick.bind(_this);
        _this.onTransitionExited = _this.onTransitionExited.bind(_this);
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        this.props.container.appendChild(this.el);
    };
    Modal.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.open !== this.props.open) {
            if (nextProps.open) {
                this.setState({
                    exited: false,
                });
            }
            else if (!getHasTransition(nextProps)) {
                this.setState({
                    exited: true,
                });
            }
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        this.props.container.removeChild(this.el);
    };
    Modal.prototype.onBackdropClick = function (event) {
        if (event.target !== event.currentTarget) {
            return;
        }
        if (!this.props.backdropClick) {
            return;
        }
        if (this.props.onBackdropClick) {
            this.props.onBackdropClick(event);
        }
        if (this.props.onRequestClose) {
            this.props.onRequestClose(event, 'backdropClick');
        }
    };
    Modal.prototype.onTransitionExited = function () {
        this.setState({
            exited: true,
        });
    };
    Modal.prototype.onContainerClick = function (event) {
        event.stopPropagation();
    };
    Modal.prototype.render = function () {
        var _a = this.props, open = _a.open, children = _a.children, backdropProps = _a.BackdropProps, backdrop = _a.backdrop, backdropClick = _a.backdropClick, onBackdropClick = _a.onBackdropClick, container = _a.container, onTransitionExited = _a.onTransitionExited, onRequestClose = _a.onRequestClose, fixed = _a.fixed, rest = tslib_1.__rest(_a, ["open", "children", "BackdropProps", "backdrop", "backdropClick", "onBackdropClick", "container", "onTransitionExited", "onRequestClose", "fixed"]);
        var hasTransition = getHasTransition(this.props);
        if (open === false && (!hasTransition || this.state.exited)) {
            return null;
        }
        var childProps = {};
        if (hasTransition) {
            childProps.onExited = createChainFunction(React.Children.only(children).props.onExited, this.onTransitionExited);
            if (!open) {
                childProps.in = false;
            }
        }
        var Container = fixed ? ModalContainer : 'div';
        var containerProps = fixed ? rest : omit(rest, ['fullScreen', 'zIndex']);
        return ReactDOM.createPortal(React.createElement(Container, tslib_1.__assign({}, containerProps, { onClick: this.onContainerClick }),
            backdrop && (React.createElement(Backdrop, tslib_1.__assign({}, backdropProps, { onClick: this.onBackdropClick, open: this.props.open }))),
            React.cloneElement(React.Children.only(children), childProps)), this.el);
    };
    Modal.defaultProps = {
        open: true,
        fixed: true,
        BackdropProps: {},
        backdrop: true,
        backdropClick: true,
        fullScreen: true,
        container: getModalRoot(),
    };
    return Modal;
}(React.Component));
export default Modal;
//# sourceMappingURL=Modal.js.map